<template>
    <fragment>
        <Header @toggle-menu="toggleMenu" />
        <main>
            <Navigation :open="menuOpen" @close="menuOpen = false" />
            <router-view/>
        </main>
        <Footer />

        <!-- Scroll to bottom button -->
        <button
            class="scroll-bottom"
            v-show="showScrollButton"
            @click="scrollToBottom"
        >
            ↓
        </button>
    </fragment>
</template>




<script>
import Header from '@/views/template/Header'
import Navigation from '@/views/template/Navigation'
import Footer from '@/views/template/Footer'

export default {
    name: 'Layout',
    components: { Footer, Header, Navigation },
    data() {
        return {
            menuOpen: false,
            showScrollButton: false
        }
    },
    methods: {
        toggleMenu() {
            this.menuOpen = !this.menuOpen
        },
        handleScroll() {
            const scrollTop = window.scrollY
            const windowHeight = window.innerHeight
            const docHeight = document.documentElement.scrollHeight

            const nearBottom = scrollTop + windowHeight >= docHeight - 50

            this.showScrollButton = scrollTop > 200 && !nearBottom
        },
        scrollToBottom() {
            window.scrollTo({
                top: document.documentElement.scrollHeight,
                behavior: 'smooth'
            })
        },

    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() { // Vue 2
        window.removeEventListener('scroll', this.handleScroll)
    },
}
</script>
